// scene type
const SCENE_TITLE = "SCENE_TITLE";
const SCENE_GAME = "SCENE_GAME";
const SCENE_DEBUG = "SCENE_DEBUG";

// modal type
const MODAL_DISABLE = "MODAL_DISABLE"
const MODAL_TIPS = "MODAL_TIPS";
const MODAL_RANKING = "MODAL_RANKING";
const MODAL_SELECT = "MODAL_SELECT";
const MODAL_DATA_LOAD = "MODAL_DATA_LOAD";
const MODAL_STAGE_CLAER = "MODAL_STAGE_CLEAR";
const MODAL_GAME_OVER = "MODAL_GAME_OVER";
const MODAL_GAME_CLEAR = "MODAL_GAME_CLEAR";
const MODAL_GAME_PAUSE = "MODAL_GAME_PAUSE";
const MODAL_STAGE_START = "MODAL_STAGE_START";
const MODAL_STAGE_TIPS = "MODAL_STAGE_TIPS";
const MODAL_SCENARIO = "MODAL_SCENARIO";
const MODAL_RESULT = "MODAL_RESULT";

export default {
    sceneType: {
        SCENE_TITLE, SCENE_GAME, SCENE_DEBUG
    },
    modalType: {
        MODAL_DISABLE, MODAL_TIPS, MODAL_RANKING, MODAL_SELECT, MODAL_DATA_LOAD, MODAL_STAGE_CLAER, MODAL_GAME_OVER, MODAL_GAME_CLEAR, MODAL_GAME_PAUSE, MODAL_STAGE_START, MODAL_STAGE_TIPS, MODAL_SCENARIO, MODAL_RESULT
    }
}